import React, { ReactElement } from 'react';
import { Box, BoxProps } from '@mui/material';

import { useStyles } from './useStyles';

const HUNDRED_PERCENT = 100;
const ZERO = 0;

interface IProgressProps extends Pick<BoxProps, 'sx' | 'children'> {
  percent?: number;
  isLoading?: boolean;
  sx?: object;
}

export function Progress({
  percent = 0,
  isLoading,
  children,
  sx,
}: IProgressProps): ReactElement {
  const { classes, cx } = useStyles();

  const isZeroPercent = percent === ZERO;
  const isHundredPercent = percent === HUNDRED_PERCENT;

  return (
    <Box className={classes.progress} sx={sx}>
      {!isZeroPercent && !isLoading && (
        <Box
          className={cx(
            classes.line,
            classes.lineMain,
            isHundredPercent && classes.noMargin,
          )}
          component="span"
          sx={{ width: `${percent}%` }}
        >
          {children}
        </Box>
      )}

      {!isHundredPercent && (
        <span className={cx(classes.line, classes.lineRest)} />
      )}
    </Box>
  );
}
